import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
var _class;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import { observer } from 'mobx-react';
import Modal from 'components/Modal';
import { Dialog, DialogTitle, DialogContent, DialogFooter, DialogButton } from 'components/Dialog';
import styles from './CreditTransactionLogModal.m.sass';
import formatCurrency from '../../../utils/formatCurrency';
import ContentLoading from '../../../components/ContentLoading';
import ContentError from '../../../components/ContentError';
import { round } from 'lodash';
import Icon from '../../../components/Icon';
import GroupedTransaction from './GroupedTransaction';
import { CSVLink } from 'react-csv';
import { translate as T } from '../../../utils/translate';
var Aux = function Aux(_ref) {
  var children = _ref.children;
  return children;
};
var CreditTransactionLogModal = observer(_class = /*#__PURE__*/function (_React$Component) {
  function CreditTransactionLogModal() {
    _classCallCheck(this, CreditTransactionLogModal);
    return _callSuper(this, CreditTransactionLogModal, arguments);
  }
  _inherits(CreditTransactionLogModal, _React$Component);
  return _createClass(CreditTransactionLogModal, [{
    key: "render",
    value: function render() {
      var state = this.props.state;
      var transactionLogViewState = state.transactionLogViewState;
      return /*#__PURE__*/React.createElement(Modal, {
        onRequestClose: function onRequestClose() {
          return state.hideTransactionModal();
        },
        isOpened: state.showingTransactionLogModal,
        position: "top",
        className: styles.tranasactionLogWrapper
      }, /*#__PURE__*/React.createElement(Dialog, {
        className: styles.dialog
      }, /*#__PURE__*/React.createElement(DialogTitle, {
        className: styles.dialogTitle
      }, "Account Summary", /*#__PURE__*/React.createElement("div", {
        className: styles.iconHolder
      }, /*#__PURE__*/React.createElement(Icon, {
        material: true,
        name: "reorder",
        title: "List View",
        onClick: transactionLogViewState.showListView,
        className: transactionLogViewState.view === 'list' ? styles.iconSelected : ''
      }), /*#__PURE__*/React.createElement(Icon, {
        material: true,
        name: "view_list",
        title: "Grouped View",
        onClick: transactionLogViewState.showGroupedView,
        className: transactionLogViewState.view === 'grouped' ? styles.iconSelected : ''
      }))), /*#__PURE__*/React.createElement(DialogContent, {
        className: styles.dialogContent
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.transactionLogHeader
      }, /*#__PURE__*/React.createElement("h1", {
        className: styles.transactionDate
      }, "Date"), /*#__PURE__*/React.createElement("h1", {
        className: styles.transactionType
      }, "Type"), /*#__PURE__*/React.createElement("h1", {
        className: styles.transactionDescription
      }, "Description"), /*#__PURE__*/React.createElement("h1", {
        className: styles.transactionAmount
      }, "Amount")), /*#__PURE__*/React.createElement("div", {
        className: styles.transactionLog
      }, transactionLogViewState.view === 'list' ? this.renderListView() : this.renderGroupedView())), /*#__PURE__*/React.createElement(DialogFooter, null, /*#__PURE__*/React.createElement("div", {
        className: styles.downloadButton
      }, /*#__PURE__*/React.createElement(CSVLink, {
        data: transactionLogViewState.csvData,
        filename: "export.csv"
      }, "Export as CSV")), /*#__PURE__*/React.createElement(DialogButton, {
        onClick: function onClick() {
          return state.hideTransactionModal();
        }
      }, "Close"))));
    }
  }, {
    key: "renderGroupedView",
    value: function renderGroupedView() {
      var _this = this;
      var state = this.props.state;
      var transactionLogViewState = state.transactionLogViewState;
      return transactionLogViewState.activate.match({
        pending: function pending() {
          return /*#__PURE__*/React.createElement(ContentLoading, {
            small: true
          });
        },
        rejected: function rejected(err) {
          return /*#__PURE__*/React.createElement(ContentError, {
            error: err
          });
        },
        resolved: function resolved() {
          return transactionLogViewState.groupedTransactions.map(function (transactionObj, index) {
            if (Array.isArray(transactionObj)) {
              return /*#__PURE__*/React.createElement(GroupedTransaction, {
                transactions: transactionObj,
                key: index,
                workspace: transactionLogViewState.rootStore.sessionStore.workspace
              });
            }
            return _this.renderSingleTransaction(transactionObj, index);
          });
        }
      });
    }
  }, {
    key: "renderListView",
    value: function renderListView() {
      var _this2 = this;
      var state = this.props.state;
      var transactionLogViewState = state.transactionLogViewState;
      return transactionLogViewState.activate.match({
        pending: function pending() {
          return /*#__PURE__*/React.createElement(ContentLoading, {
            small: true
          });
        },
        rejected: function rejected(err) {
          return /*#__PURE__*/React.createElement(ContentError, {
            error: err
          });
        },
        resolved: function resolved() {
          return transactionLogViewState.transactions.slice(0).reverse().map(_this2.renderSingleTransaction);
        }
      });
    }
  }, {
    key: "renderSingleTransaction",
    value: function renderSingleTransaction(transaction, index) {
      var _this3 = this;
      return /*#__PURE__*/React.createElement("div", {
        className: styles.transactionWrapper,
        key: index
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.transactionDate
      }, transaction.dateCreated.format('LL')), /*#__PURE__*/React.createElement("div", {
        className: styles.transactionType
      }, transaction.transactionType.includes('ADMIN_') ? 'ADJUSTMENT' : transaction.transactionType), /*#__PURE__*/React.createElement("div", {
        className: styles.transactionInfo
      }, transaction.member && /*#__PURE__*/React.createElement("p", null, T('Web.Common.Client', 'Client'), " Name:", ' ', /*#__PURE__*/React.createElement("strong", null, transaction.member.displayName)), transaction.job && /*#__PURE__*/React.createElement(Aux, null, /*#__PURE__*/React.createElement("p", null, "Job Name:", ' ', /*#__PURE__*/React.createElement("strong", null, transaction.job.name || transaction.job.description)), /*#__PURE__*/React.createElement("p", null, "Job Id:", ' ', /*#__PURE__*/React.createElement("strong", {
        className: styles.iconHolder,
        onClick: function onClick() {
          return window.open("/".concat(_this3.props.workspace.slug, "/jobs/").concat(transaction.job.id), '_blank');
        }
      }, transaction.job.id))), transaction.metadata.description && /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("strong", null, transaction.metadata.description))), /*#__PURE__*/React.createElement("div", {
        className: styles.transactionAmount
      }, (transaction.transactionType === 'PURCHASE' || transaction.transactionType === 'ADMIN_REMOVE') && /*#__PURE__*/React.createElement("div", {
        className: styles.purchase
      }, "- ", formatCurrency(round(transaction.amount / 100, 2))), (transaction.transactionType === 'DEPOSIT' || transaction.transactionType === 'BONUS' || transaction.transactionType === 'REFUND' || transaction.transactionType === 'ADMIN_ADD') && /*#__PURE__*/React.createElement("div", {
        className: styles.deposit
      }, "+ ", formatCurrency(round(transaction.amount / 100, 2)))));
    }
  }]);
}(React.Component)) || _class;
export { CreditTransactionLogModal as default };
//# sourceMappingURL=index.js.map
